// extracted by mini-css-extract-plugin
export default {"container":"CbFooter_container__bzomD","logoWrapper":"CbFooter_logoWrapper__Pu93z","logo":"CbFooter_logo__OZ5BY"};